/**
 * Labels for the Main Dashboard's four 7-day buckets, NEWEST first, matching the procs'
 * result sets (sp_getAreaTypeSummary, sp_getCaregiverSummary):
 *   week1 = 1..7 days ago, week2 = 8..14, week3 = 15..21, week4 = 22..28.
 *
 * Shared by Response Time Trends and Top 10 Caregiver Review. The trends chart used to
 * build its own (-28→-21, -21→-14, -14→-8, -8→-1), which was a day off and overlapped.
 * Built on call, not at module load, so a page left open past midnight relabels.
 */
import { formatDateNoYear, getToday } from '../../../libs.jsx';

const BUCKETS = [[-7, -1], [-14, -8], [-21, -15], [-28, -22]];

export function dashboardWeekRanges() {
    return BUCKETS.map(([from, to]) => `${formatDateNoYear(getToday(from))}–${formatDateNoYear(getToday(to))}`);
}
